import React, { useState } from 'react';

import AvatarPlaceholder from './AvatarPlaceholder';

const Avatar = (props: {
  src?: string;
  fallbackString?: string;
  width?: string | number;
  height?: string | number;
  styles?: {
    imgContainer?: React.CSSProperties;
    imgElement?: React.CSSProperties;
    placeholder?: React.CSSProperties;
  };
}) => {
  const [hasErrored, setHasErrored] = useState(false);
  return props.src && !hasErrored ? (
    <div style={props.styles?.imgContainer}>
      <img
        src={props.src}
        style={{
          width: props.width ?? '40px',
          height: props.height ?? '40px',
          borderRadius: '200px',
          objectFit: 'cover',
          ...props.styles?.imgElement,
        }}
        alt='avatar'
        onError={() => setHasErrored(true)}
      />
    </div>
  ) : (
    <AvatarPlaceholder
      style={{
        width: props.width ?? '40px',
        height: props.height ?? '40px',
        ...props.styles?.placeholder,
      }}
      stringToUse={props.fallbackString}
    />
  );
};

export default Avatar;
